<template>
    <div class="flow-v2-callstack" style="flex-grow: 1; display: flex; flex-direction: column;">
        <AgGridVue
                   style="flex-grow: 1; display: flex; flex-direction: column;"
                   :rowData="rowData"
                   :columnDefs="columnDefs"
                   :headerHeight="30"
                   :rowHeight="33"
                   :defaultColDef="defaultColDef"
                   :cellSelection="false"
                   :getRowStyle="getRowStyle"
                   @grid-ready="gridReady"
                   @row-clicked="rowClicked"
                   @cell-double-clicked="rowClicked"
                   @cell-key-down="cellKeyDown"
        >

        </AgGridVue>
    </div>
</template>

<script>
    import { AgGridVue } from "ag-grid-vue3";
    import { mapCache } from '../shared/helpers.js';
    import utils from '../../../../../Shared/utils.jsx';

    export default {
        name: 'flow-v2-debugcallstack',
        mixins: [
        ],
        components: {
            AgGridVue
        },
        emits: ['activate', 'double-click'],
        props: {
            items: null,
            index: null,
            execIndex: { default: 0 },
            idToName: null,
        },
        data() {
            return {
                gridApi: null,
                columnApi: null,

                searchText: '',
                rowData: [],
                columnDefs: [
                    {
                        headerName: '',
                        colId: 'marker',
                        width: 36,
                        maxWidth: 36,
                        minWidth: 28,
                        sortable: false,
                        resizable: false,
                        cellRenderer: (p) => {
                            const i = p.node.rowIndex;
                            if (i === this.execIndex)
                                return '<span class="flow-v2-stack-marker flow-v2-stack-marker--exec">▶</span>';
                            if (i === this.index)
                                return '<span class="flow-v2-stack-marker flow-v2-stack-marker--view">▶</span>';
                            return '';
                        },
                    },
                    {
                        headerName: 'Name',
                        field: 'name',
                        flex: 1,
                    },
                    {
                        headerName: 'Icon',
                        field: 'id',
                        flex: 1,
                    },
                    {
                        headerName: 'Line',
                        field: 'line',
                        width: 80,
                    },
                    {
                        headerName: 'Column',
                        field: 'column',
                        width: 80,
                    },
                ],
                defaultColDef: {
                },
            }
        },
        created() {
        },
        async mounted() {
            if (this.items) {
                this.rowData = await this.transformStack(this.items);
                if (this.gridApi)
                    this.gridApi.setGridOption("rowData", this.rowData);
            }
        },
        computed: {
        },
        watch: {
            items: {
                async handler(newv) {
                    this.rowData = await this.transformStack(newv);
                    this.gridApi?.setGridOption("rowData", this.rowData);
                },
                deep: true
            },
            index() {
                this.gridApi?.redrawRows();
            },
            execIndex() {
                this.gridApi?.redrawRows();
            },
        },
        methods: {
            gridReady(params) {
                this.gridApi = params.api;
                this.columnApi = params.columnApi;
            },
            getRowStyle(params) {
                const style = { cursor: 'pointer' };
                if (params.rowIndex == this.index)
                    style.background = '#afcfef';
                else if (params.rowIndex == this.execIndex)
                    style.background = '#fff3bf';
                return style;
            },
            activateRow(rowIndex) {
                if (rowIndex == null || rowIndex < 0)
                    return;
                this.$emit('activate', rowIndex);
                this.$emit('double-click', rowIndex);
            },
            rowClicked(event) {
                this.activateRow(event.rowIndex);
            },
            cellKeyDown(event) {
                const key = event.event?.key;
                if (key === 'Enter' || key === ' ') {
                    event.event?.preventDefault?.();
                    this.activateRow(event.rowIndex);
                }
            },
            async transformStack(stack) {
                const rows = [];
                for (let current of stack || []) {
                    let url = `Apps/FlowV2/GetDebugMapFromName`;
                    url += `?ContainerFullName=${current.ProjectName}`;
                    url += `&ClassName=${current.ClassName}`;
                    url += `&MethodName=${current.MethodName}`;

                    let flowMap = mapCache.debugMap[url];
                    if (!flowMap) {
                        try {
                            flowMap = await utils.api.get(url);
                        }
                        catch (err) {
                            console.error(err.message, err);
                            rows.push({
                                name: current.MethodName,
                                id: 'External',
                                line: (current.Line ?? -1) + 1,
                                column: (current.Column ?? -1) + 1,
                            });
                            continue;
                        }
                        if (flowMap)
                            mapCache.debugMap[url] = flowMap;
                    }

                    if (!flowMap || !flowMap.ItemMap) {
                        rows.push({
                            name: current.MethodName,
                            id: 'External',
                            line: 0,
                            column: 0,
                        });
                        continue;
                    }

                    const map = Object.keys(flowMap.ItemMap).map(a => ({ InstanceID: a, NumberId: flowMap.ItemMap[a] }));
                    const item = map.find(a => a.NumberId == current.Id);

                    rows.push({
                        name: current.MethodName,
                        id: item ? this.idToName(item.InstanceID) ?? '?' : '',
                        line: current.Line +1,
                        column: current.Column +1,
                    });
                }
                return rows;
            },
        }
    };
</script>

<style scoped>
    .flow-v2-callstack :deep(.flow-v2-stack-marker--exec) {
        color: #ca8a04;
        font-weight: 700;
    }
    .flow-v2-callstack :deep(.flow-v2-stack-marker--view) {
        color: #16a34a;
        font-weight: 700;
    }
</style>
